import { toast, type ExternalToast } from 'sonner';

/**
 * Единый imperative-слой уведомлений админки поверх sonner.
 * ВСЕ уведомления (и notificationProvider, и компоненты) ходят через notify —
 * один формат, единые per-type duration, дедупликация по id.
 * Прямой import { toast } from 'sonner' допустим ТОЛЬКО здесь и в components/ui/sonner.tsx (Toaster).
 */
const DURATION = { success: 4000, info: 4000, warning: 5000, error: 6000 } as const;

type NotifyOpts = ExternalToast;

export const notify = {
  success: (msg: string, o?: NotifyOpts) => toast.success(msg, { duration: DURATION.success, ...o }),
  error: (msg: string, o?: NotifyOpts) => toast.error(msg, { duration: DURATION.error, ...o }),
  info: (msg: string, o?: NotifyOpts) => toast.info(msg, { duration: DURATION.info, ...o }),
  warning: (msg: string, o?: NotifyOpts) => toast.warning(msg, { duration: DURATION.warning, ...o }),
  loading: (msg: string, o?: NotifyOpts) => toast.loading(msg, o),
  dismiss: (id?: string | number) => toast.dismiss(id),
} as const;
